export const locale = {
    lang: 'en',
    data: {
      'RESULTADOS': {
        'TITULO': 'REPORTING',
        'DESCRIP': 'Select an option',
        'CARGANDO': 'Loading company survey results',
        'COMINGSOON': 'COVID Survey results coming soon...',
        'VALIDANDO': {
          'BOTON': 'On validation process',
          'MENSAJE': 'The results of this product are in process, they will available to you soon',
        },
        'TABLAPRODUCTOS':{
          'COL1':'Year',
          'COL2':'Access',
          'BOT':'Access',
        },

        'SECCIONES': {
          'TITULO_VER':'Version ',
          'NOSECCIONES': 'There are not sections available',

          'CERTIFICAR': {
            'TITULO': 'CERTIFY',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'MEDIR': {
            'TITULO': 'MEASUREMENT',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'PULSE': {
            'TITULO': 'PULSE CHECK',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'MEDIR_AMCO': {
            'TITULO': 'ICI',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'MEDIR_INNO': {
            'TITULO': 'Innmotion survey',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'CertiAdicio': {
            'TITULO': 'ADDITIONAL CERTIFICATIONS',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'Amco': {
            'TITULO': 'AMCO',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'TrabDign': {
            'TITULO': 'DIGNIFICANT WORK',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'PrimEmp': {
            'TITULO': 'FIRST JOB',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'GOFLOW': {
            'TITULO': 'GoFlow Results',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
        },

        'TABPRIN':{
          'TABPRO':'Certification processes',
          'TAB4ALL': 'FORALL results',
          'TAB4ALL2': 'Processe results',
          'TITURES': 'FORALL Results',
          'TABCER':'Measurer processes',
          'TABPULSE':'Pulse check processes',
          'TABICI': 'ICI Results',
          'TABINNO': 'Innmotion survey results',
          'TABAMCO': 'AMCO processes',
          'TABTRABDIG': 'Decent Work Processes',
          'TABPRIEMP': 'First employment processes',

        },
        'TABPRIN5':{
          'TABPRO':'Global versión 3.1 process',
          'TAB4ALL':'Resultados FORALL',
          'TAB4ALL2':'Proceso de FORALL',
          'TITURES':'Resultados FORALL',
          'TABCER':'Lider versión 3.2 Lider process',
          'TABPULSE':'Covid versión 3.3 process',
        },
        '4ALLVIEJAS':{
         'TITULO': 'FORALL inherited results',
         'BOTON': 'Start',
         'SIN_4ALL_HEREDADAS':"You don't count on inherited FORALL results",
         'TITULOCERTIFICAR':'Certify',
         'APLICACIONANIO':'Application year: 2019',
        },
        '4ALL':{
            'CARGANDO':'Loading FORALL results',
             'TITULO4ALL': 'PRACTICE RESULTS',
             'TABPRACTICAS':{
              'TITULOTAB': 'Practices 4all',
              'TITULOPRACGLOBAL':{
              'SUBTITULOPRAC': 'Global result of FORALL practices',
              'TEXTO1':'Percentage of ',
              'TEXTO2': 'knowledge of FORALL practices',
              'TEXTO3': 'in your organization',
              'TEXTO4': 'Level of',
              'TEXTO5': 'satisfaction of the collaborators they know',
              'TEXTO6': 'FORALL practices',
            },
            'TITULOPRAC4All':{
              'TITULOTAB': 'Demographics',
              'SUBTITULO4ALL': 'Results by FORALL practices',
              'TITULOCONO': 'KNOWLEDGE',
              'TEXTO1': 'Knowledge percentage of FORALL practices in your organization',
              'TITULOSATIS': 'SATISFACTION',
              'TEXTO2': 'Level of satisfaction of employees who know the FORALL practice',
            }
          },

        'DEMOGRAFICOS':{
          'Cargo homologado ': 'Approved position',
          'Años de Trabajo': 'Antique',
            'Condición de trabajo': 'Working Condition',
            'Tipo de trabajo': 'Compensation Scheme',
            'Género': 'Gender',
            'Educación': 'Academic Degree',
            'PORCONOTXT1': 'Percentage of',
            'PORCONOTXT2': 'knowledge of FORALL practices',
            'PORCONOTXT3': 'by demographic cut',
            'PORSATITXT1': 'Level of',
            'PORSATITXT2': 'satisfaction of the employees who know the FORALL practices',
            'PORSATITXT3': 'by demographics',
         },
         'MODL_N_RESU':'There are currently no results',
         'MODL_N_RESU_4ALL':'Unable to display requested results',
         },
         "ETIQ_MODAL_RESULT":{
           "TITLE_MODA":'No result platformKey found',
           "ETQ_PROD": "Product: ",
           "ETQ_BROK": "Broker: ",
           "ETQ_COUN": "Country: ",
           "ETQ_LANG": "Language: ",
           "ETQ_CERTY": "Certificate: ",
           "true": "Enabled",
           "false": "Disabled",
           "COUNTR_NO_SELEC":"*Not selected*",
         }
      },
      'RESULTADOS_5':{
        'TITULO': 'Results 5.0',
        'SECCIONES': {
          'NOSECCIONES': 'No available',
          '31': {
            'TITULO': 'global version 3.1',
            'INFO': 'Select the year you want consult',
            'BOTON': 'Go'
          },
          '32': {
            'TITULO': 'Leader version 3.2',
            'INFO': 'Select the year you want consult',
            'BOTON': 'Go'
          },
          '33': {
            'TITULO': 'Covid version 3.3',
            'INFO': 'Select the year you want consul',
            'BOTON': 'Go'
          }
        },
      },
      'CONFING_RESUL':{
      'TITULO_MODAL':'BenchMarks results configuration',
      'TAB_DEMO_EXCEL':'Excel demographics',
      'SUB_TIT_TAB_DEMO_EXCEL':'Select demographics:',
      'TAB_DEMO_ENCU':'Demographics survey',
      'SUB_TIT_TAB_DEMO_ENCU':'Select demographics:',
      'TAB_BENCHMA':'BenchMarks',
      'SUB_TIT_TAB_BENCHMA':'',
      'TITULO_MAT_EXPAN_TAMANO':'Top',
      'TITULO_MAT_EXPAN_SECTOR':'Sectorial',
      'TITULO_MAT_EXPAN_REGIONAL':'Ranges',
      'OKSELECT':'Selected',
      'NOTSELECT':'Not selected',
      'TAB_NIV_GEOG':'Geographic levels',
      'SUB_TIT_TAB_NIV_GEOG':'Select geographic levels:',
      'TAB_NIV_ESTRUC':'Structural levels',
      'SUB_TIT_TAB_NIV_ESTRUC':'Select the structural levels:',
      'BTN_ACEPTAR':'Accept',
      'MODAL_CARGA_DEMO_EXC':'Loading demographics',
      'MODAL_CARGA_DEMO_ENC':'Loading survey demographics',
      'MODAL_CARGA_BENCH':'Loading BenchMarks',
      'MODAL_CARGA_NIV_GEO':'Loading geographic levels',
      'MODAL_CARGA_NIV_ESTR':'Loading structural levels',
      'TAB_BENCH_MARK':'BenchMarks',
      'MODAL_CARGA_BENCH_MARK':'Loading BenchMarks',
      'SUB_TIT_TAB_BENCH_MARK':'Select BenchMark:',
      'SUCCES_GUAR_SELEC':'The modifications were saved correctly',
      'CONFI_GUAR_SELE':'Are you sure to save the changes made?',
      'RES_SI':'Yes',
      'RES_NO':'No',
      'MAT_TOOL_BTN_CONFI_RESULT':'Results configuration',
      'MODAL_GUA_INFOR':'Saving Information',
      'SUB_TIT_TAB_HIERARCHI':'HierarchicalPaths selection:',
      'MODAL_CARGA_HIERARCHI':'Loading HierarchicalPaths',
      'SIN__HIERARCHI_MOSTRAR':'There are currently no results in hierarchicalPaths',
      'EXTERNAL_PORTAL':'Copy the url of external 4all',
      'INTRU_TEX_BENCHMARK':'*Move benchmarks',
      'BENCHMARCK_SELEC':'BenchMarks selected in order of presentation:',
      'BTN_SAV_BENCH':'Save BenchMarks',
      'TEX_SEARC_BENCH_TOP':'Enter top BenchMark to search',
      'TEX_SEARC_BENCH_SECT':'Enter sector BenchMark to search',
      'TEX_SEARC_BENCH_RANG':'Enter BenchMark range to search',
      'TEX_SEARC_BENCH':'Enter BenchMark to search',
      'INFO_MAS_BENCH_ESPA':'grouped BenchMarks',
      'BTN_ADD_BENCH_SUGE':'Add suggested',
      'MOD_WARN_MAX_PERMIT':'It is not possible to add it, because it exceeds the number of allowed spaces',
      'MOD_WARN_UN_CATE':'Currently a BenchMarks of the selected catergory already exists',
      'MOD_WARN_NO_APLIC':'It is not possible to add it, as the option not to select the BenchMarks is enabled.',
      'INSTRU_DRAP&DROP_1':'Drag and drop the BenchMark here',
      'LABE_CIRC_PROGRE':'BenchMarks',
      'LABE_INSTRU_SELECT_BENCH':'¿Do you want to select BenchMarks?',
    },
    'CONFING_RESUL_GOFLOW':{
    'TITULO_MODAL':'GoFlow Results Information',
      },
    'CONFING_RESUL_EMP':{
      'TITULO_MODAL':'Raw Data Emprising',
          'INT_TEX':'Instruction: Please upload the Raw Data file to be imported',
          'TOOLT_CHA_INF':'I selected the file',
          'UPLO_INF':'Importing row data',
          'SUCC_UPLO_INF':'Imported successfully',
    }
    }
};
